import { useState, type FormEvent } from 'react'
import { useAuth } from '@/hooks/useAuth'
import { Button } from '@/components/shared/Button'
import { Spinner } from '@/components/shared/Spinner'

export function LoginPage() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const { login } = useAuth()

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setError(null)
    setLoading(true)
    try {
      await login(username, password)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-surface-card rounded-xl shadow-lg border border-border-subtle p-10 w-full max-w-sm">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-10 h-10 bg-brand-blue rounded-lg flex items-center justify-center shadow-xs">
            <span className="font-bold text-lg text-white tracking-tight">M</span>
          </div>
          <div>
            <h1 className="font-semibold text-lg text-text-primary">Cap Manager</h1>
            <p className="text-[11px] text-text-muted uppercase tracking-wide">MABAC Media</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-text-secondary mb-1">
              Username
            </label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="Enter your username"
              required
              className="w-full px-3 py-2 rounded-lg bg-surface-card border border-gray-300 text-sm text-text-primary
                focus:outline-none focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/10
                placeholder:text-text-placeholder"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-text-secondary mb-1">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              className="w-full px-3 py-2 rounded-lg bg-surface-card border border-gray-300 text-sm text-text-primary
                focus:outline-none focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/10
                placeholder:text-text-placeholder"
            />
          </div>

          {error && (
            <p className="text-sm text-brand-red">{error}</p>
          )}

          <Button type="submit" disabled={loading} className="w-full">
            {loading ? <Spinner className="w-4 h-4" /> : 'Sign in'}
          </Button>
        </form>
      </div>
    </div>
  )
}
